import styled from "styled-components";
import { colors, typography } from "src/theme";
import device from "src/constants/media";

export const Wrapper = styled.div<{ isOpen: boolean }>`
  border-bottom: 1px solid ${colors.white};

  transition: 0.3s all ease;
  height: ${({ isOpen }) => (isOpen ? "auto" : "50px")};
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 12px 0;
`;

export const Text = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.white};
  @media ${device.laptop} {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 210px;
  }
`;
export const ImageContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 32px;
  height: 32px;
`;
export const NextImageWrapper = styled.div``;

export const ListWrapper = styled.ul`
  list-style: none;
  padding: 12px 0;
`;

export const ListItem = styled.li`
  cursor: pointer;
  margin-bottom: 15px;

  :hover {
    text-decoration: underline;
  }
`;
